import type { FormattedNewWager } from '@library/types/newWagers';
import { Loading } from '@library/components/Loading';
import { classNames } from '@library/utils';

export interface MemberEntryModalStatusProps {
  isError: boolean;
  isLoading: boolean;
  selectedNewWager: FormattedNewWager | undefined;
}

export const MemberEntryModalStatus = ({
  isError,
  isLoading,
  selectedNewWager
}: MemberEntryModalStatusProps) => {
  if (!isLoading && !isError && selectedNewWager) {
    return null;
  }

  return (
    <div
      className={classNames(
        'm-auto p-6 text-xl font-bold',
        isError ? 'text-roses' : 'text-soClean-100'
      )}
    >
      {isLoading && <Loading loadingMessage="Loading Entry Details" />}
      {!isLoading && isError && <p>Error Fetching Entry Details</p>}
      {!isLoading && !isError && !selectedNewWager && (
        <p>Unable to find Entry Details</p>
      )}
    </div>
  );
};
